module.exports = __webpack_public_path__ + "img/WeThrive-Logo.5030d19e.png";